import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AllDealsComponent } from './all-deals.component';

const routes: Routes = [{ path: '', component: AllDealsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AllDealsRoutingModule {}
